<template>
  <div :class="$style.wrapper">
    <v-hex v-if="stage > 0" initialColor="blue" />
    <v-score />
    <v-labels :stageNumber="3" :currentStageNumber="labelsStage"/>
    <transition name="reveal" mode="out-in">
      <v-comics v-if="stage === 0" @success="next" :key="1" :items="['/comics/start/1.svg', '/comics/start/2.svg', '/comics/lesson2/trainer2/6.svg', '/comics/lesson2/trainer2/7.svg']" />
      <trainer1 v-if="stage === 1 || stage === 2" @success="next" />
      <v-comics v-if="stage === 3" @success="next" :key="3" :items="['/comics/lesson2/trainer3/8.svg', '/comics/lesson2/trainer3/9.svg']" />
      <trainer2 v-if="stage === 4 || stage === 5" @success="next" />
      <v-comics v-if="stage === 6" @success="next" :key="4" :items="['/comics/lesson3/trainer3/10.svg']" />
      <trainer3 v-if="stage === 7 || stage === 8" @success="next" />
      <v-comics v-if="stage === 9" @success="next" :key="5" :items="['/comics/end/11.svg']" />
    </transition>
    <v-achievement ref="achievement" @click="next" />
  </div>
</template>
<script>
import trainer1 from './components/trainer1/trainer1'
import trainer2 from './components/trainer2/trainer2'
import trainer3 from './components/trainer3/trainer3'

import saveDataMixin from '@/mixins/saveData'

export default {
  name: 'lesson3',
  components: { trainer1, trainer2, trainer3 },
  mixins: [saveDataMixin],
  data: () => ({
    // todo вернуть 0
    stage: 0,
  }),
  computed: {
    labelsStage() {
      const { stage } = this
      if (stage > 6) return 3
      if (stage > 3) return 2
      return 1
    },
  },
  methods: {
    next() {
      if (this.stage === 1) this.$refs.achievement.grant('consultant')
      if (this.stage === 4) this.$refs.achievement.grant('web')
      if (this.stage === 7) this.$refs.achievement.grant('expert')

      if (this.stage === 9) {
        this.pushToHub()
        return
      }
      this.stage += 1
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  height: 100%;
  min-height: 78rem;
}
</style>
